import React from 'react';
import '../assets/styles/endgame.css';

function Endgame(props) {
    return (props.trigger) ? (
        <div className="endgame-tictactoe">
            {props.title}
            <button onClick={props.playAgain} className="againBtn-tictactoe">Wanna try again?</button>
            <button onClick={props.reset} className='againBtn-tictactoe' >Reset</button>
            <button onClick={() => props.setShowHistory(true)} className='againBtn-tictactoe' >Show history</button>
        </div>
    ) : '';
}


export default Endgame;